import {Button, Grid, Stack, Typography} from '@mui/material';
import {Product} from '../../../__generated__/resolvers-types';
import CenteredText from '../../../components/centeredText/CenteredText';
import SubscriptionPlanFeature from './SubscriptionPlanFeature';

export interface SubscriptionPlanProps {
  products: Product[];
  stripeRole: string;
  handleManageSubscription: () => void;
}

export default function SubscriptionPlan({products, handleManageSubscription, stripeRole}: SubscriptionPlanProps) {
  const currentProduct = products.find((product) => product.role === stripeRole);

  if (!currentProduct) {
    return <CenteredText text="No product found" minHeight={300} />;
  }

  return (
    <Stack spacing={3} justifyContent="center">
      <Grid container spacing={1} justifyContent="start" alignItems="center" direction="row">
        <Typography variant="h6" gutterBottom>
          Current Plan:
        </Typography>
        <Typography variant="body1" gutterBottom>
          {currentProduct.name}
        </Typography>
        <Button variant="contained" color="primary" onClick={handleManageSubscription} sx={{ml: 2, mr: 2}}>
          Manage Subscription
        </Button>
      </Grid>

      {currentProduct.description && (
        <Typography variant="body1" gutterBottom>
          {currentProduct.description}
        </Typography>
      )}

      <SubscriptionPlanFeature features={currentProduct.features} />
    </Stack>
  );
}
